import { render, staticRenderFns } from "./AddTag.vue?vue&type=template&id=4c00e2ee&scoped=true&"
import script from "./AddTag.vue?vue&type=script&lang=js&"
export * from "./AddTag.vue?vue&type=script&lang=js&"
import style0 from "./AddTag.vue?vue&type=style&index=0&id=4c00e2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c00e2ee",
  null
  
)

export default component.exports